import { createUseStyles } from 'react-jss';

import { ViboTheme } from 'types/theme';

const useStyles = createUseStyles((theme: ViboTheme) => ({
  prepModePage: {
    '& .sectionBlocksHeader': {
      margin: '0 0 12px 0',
    },

    '& .timelineSectionsHeader > div': {
      '&.searchBarWrapper': {
        minWidth: 'auto',
      },
    },

    '& .sections': {
      '& .viboScrollbar': {
        paddingTop: '8px',

        '@media screen and (min-width: 1441px) ': {
          paddingTop: '10px',
        },
      },

      '& .timelineSection': {
        '&:first-child': {
          marginTop: '0',
        },
      },
    },
  },

  eventTitle: {
    margin: '0 0 14px 0',
  },

  sectionsTimeline: {
    '& .timelineSection': {
      '&:not(:last-child)': {
        margin: '0 0 10px 0',

        '@media screen and (min-width: 1441px) ': {
          margin: '0 0 12px 0',
        },
      },
    },
  },

  progressBtn: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    cursor: 'pointer',
    color: 'inherit',

    '&.done': {
      color: theme.palette.success.main,
    },

    '& .viboIcon': {
      color: 'inherit',
      margin: ' 0 4px 0 0',
    },
  },

  isDoneIcon: {
    '&.isDone': {
      color: theme.palette.success.main,
    },
  },

  selectComputerBtn: {
    '& .content': {
      ...theme.mixins.longText,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },

    '& .label': {
      color: theme.palette.text.secondary,
      margin: '0 4px 0 0',
    },

    '& .name': {
      ...theme.mixins.longText,
    },
  },
}));

export default useStyles;
